module.exports = __webpack_public_path__ + "static/media/16-12.04f5b221.mp3";